import * as React from "react";
import { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgMultipleEnvelopes = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" width="1em" height="1em" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M32 3.047H6.294v6.627H0v19.279h25.706v-6.627H32zm-7.9 24.3H1.606v-11.02l10.4 6.493h1.697L24.1 16.326zm0-12.918-11.246 7.027L1.605 14.43v-3.147h22.493v3.147zm6.292 6.291h-4.686v-8.027l4.686-2.997zm0-12.92-4.686 2.949V9.674H7.9V4.655h22.493z" /></svg>;
export default SvgMultipleEnvelopes;